import { default as teacherPositionCategory } from './position-category/store' 

export default { 
	teacherPositionCategory 
}
